import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const PlusIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M20 13h-7v7h-2v-7H4v-2h7V4h2v7h7z" />
  </BaseIcon>
)
